/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_c0c0a405{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.rootVertical_c0c0a405{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item_c0c0a405{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n"}]);
export const root = "root_c0c0a405";
export const rootVertical = "rootVertical_c0c0a405";
export const item = "item_c0c0a405";